import { render, staticRenderFns } from "./fontEditDialog.vue?vue&type=template&id=55484c19&"
import script from "./fontEditDialog.vue?vue&type=script&lang=js&"
export * from "./fontEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports